


export const smallImageInputUIConditionsMet = ({width, height}) => {
    return width < 300 || height < 300 
}